export const getGMTOffset = (): string => {
  const offset = -new Date().getTimezoneOffset(); // Делаем знак правильным
  const hours = Math.floor(offset / 60);
  const minutes = offset % 60;
  const sign = hours >= 0 ? "+" : "-";
  return `GMT${sign}${String(Math.abs(hours)).padStart(2, "0")}:${String(Math.abs(minutes)).padStart(2, "0")}`;
}

export const toLocalISOString = (input: Date | string): string => {
  const date: Date =
    typeof input === 'string'
      ? (() => {
        const parsed = new Date(input);
        if (isNaN(parsed.getTime())) {
          throw new Error(`Invalid date string: "${input}"`);
        }
        return parsed;
      })()
      : input;

  const pad = (n: number): string => String(n).padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const millis = String(date.getMilliseconds()).padStart(3, '0');

  const tzOffset = -date.getTimezoneOffset(); // в минутах
  const sign = tzOffset >= 0 ? '+' : '-';
  const tzHours = pad(Math.floor(Math.abs(tzOffset) / 60));
  const tzMinutes = pad(Math.abs(tzOffset) % 60);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}${sign}${tzHours}:${tzMinutes}`;
};
export const toLocalISOStringWithoutTimezone = (input: Date | string): string => {
  // Если вход — строка, создаём Date
  const date: Date = typeof input === 'string' ? new Date(input) : input;

  // Проверка корректности даты
  if (isNaN(date.getTime())) {
    throw new Error(`Invalid date input: "${input}"`);
  }

  const pad = (n: number): string => String(n).padStart(2, '0');

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const millis = String(date.getMilliseconds()).padStart(3, '0');

  // Собираем строку в ISO формате без часового пояса
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}`;
};
